<template>
    <div class="asset-use-box">
        <div class="asset-use-title">
            <HeaderNav
                header-title="资产使用"
                left-icon-name="2"
                right-icon-name="2"
                @change-org="getNewOrgId"
            ></HeaderNav>
            <div @click="showPickerTime = true" class="title-tips">
                <span class="iconfont iconrili"></span>
                <p>{{ selectTimeYear }}年{{ selectTimeMonth }}月份，中国联合水泥商混业务产销概况</p>
            </div>
        </div>
        <div
            class="picker-content"
            v-show="showPickerTime"
        >
            <van-datetime-picker
                v-model="currentDate"
                :max-date="maxDate"
                type="year-month"
                @confirm="selectTime"
                @cancel="showPickerTime = false"
            ></van-datetime-picker>
        </div>
        <div class="asset-use-box-center">
            <van-tabs
                @change="changeActive"
                v-model="active"
                line-width="80"
                title-active-color="#3495FB"
                color="#3495FB"
            >
                <van-tab title="产能">
                    <div class="tab-one">
                        <h2 class="tab-title-one">
                            商砼
                        </h2>
                        <div class="top-two-block">
                            <div>
                                <h3>运行生产线占比</h3>
                                <p class="two-p-red">
                                    {{ getCapacityConcreteData.number_ratio | toFixedNumber }}%
                                </p>
                            </div>
                            <div>
                                <h3>总产能利用率</h3>
                                <p class="two-p-violet">
                                    {{ getCapacityConcreteData.ability_ratio | toFixedNumber }}%
                                </p>
                            </div>
                        </div>
                        <div class="top-three-block">
                            <div class="three-title">
                                <h2>生产线数量</h2>
                                <span>单位(条)</span>
                            </div>
                            <div class="three-content">
                                <p>总数量:<span>{{ getCapacityConcreteData.number }}</span></p>
                                <p>运行数量:<span>{{ getCapacityConcreteData.number_use }}</span></p>
                                <p>闲置数量:<span>{{ getCapacityConcreteData.number_free }}</span></p>
                            </div>
                        </div>
                        <div id="threeChart"></div>
                        <div class="line-ability">
                            <div class="three-title">
                                <h2>生产线能力</h2>
                                <span>单位(万方)</span>
                            </div>
                            <div class="ability-content">
                                <div>
                                    <span>总能力</span>
                                    <p>{{ getCapacityConcreteData.ability | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>运行</span>
                                    <p>{{ getCapacityConcreteData.ability_use | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>闲置</span>
                                    <p>{{ getCapacityConcreteData.ability_free | toFixedNumber }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="line-ability">
                            <div class="three-title">
                                <h2>生产线价值</h2>
                                <span>单位(万元)</span>
                            </div>
                            <div class="ability-content">
                                <div>
                                    <span>总价值</span>
                                    <p>{{ getCapacityConcreteData.value | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>运行</span>
                                    <p>{{ getCapacityConcreteData.value_use | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>闲置</span>
                                    <p>{{ getCapacityConcreteData.value_free | toFixedNumber }}</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="tab-one">
                        <h2 class="tab-title-one">
                            砂浆
                        </h2>
                        <div class="top-two-block">
                            <div>
                                <h3>运行生产线占比</h3>
                                <p class="two-p-red">
                                    {{ getCapacityMortarData.number_ratio | toFixedNumber }}%
                                </p>
                            </div>
                            <div>
                                <h3>总产能利用率</h3>
                                <p class="two-p-violet">
                                    {{ getCapacityMortarData.ability_ratio | toFixedNumber }}%
                                </p>
                            </div>
                        </div>
                        <div class="top-three-block">
                            <div class="three-title">
                                <h2>生产线数量</h2>
                                <span>单位(条)</span>
                            </div>
                            <div class="three-content">
                                <p>总数量:<span>{{ getCapacityMortarData.number || 0 }}</span></p>
                                <p>运行数量:<span>{{ getCapacityMortarData.number_use || 0 }}</span></p>
                                <p>闲置数量:<span>{{ getCapacityMortarData.number_free || 0 }}</span></p>
                            </div>
                        </div>
                        <div id="threeChartT"></div>
                        <div class="line-ability">
                            <div class="three-title">
                                <h2>生产线能力</h2>
                                <span>单位(万方)</span>
                            </div>
                            <div class="ability-content">
                                <div>
                                    <span>总能力</span>
                                    <p>{{ getCapacityMortarData.ability | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>运行</span>
                                    <p>{{ getCapacityMortarData.ability_use | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>闲置</span>
                                    <p>{{ getCapacityMortarData.ability_free | toFixedNumber }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="line-ability">
                            <div class="three-title">
                                <h2>生产线价值</h2>
                                <span>单位(万元)</span>
                            </div>
                            <div class="ability-content">
                                <div>
                                    <span>总价值</span>
                                    <p>{{ getCapacityMortarData.value | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>运行</span>
                                    <p>{{ getCapacityMortarData.value_use | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>闲置</span>
                                    <p>{{ getCapacityMortarData.value_free | toFixedNumber }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="劳动生产率">
                    <div class="labour-production">
                        <div class="top-block-ride-four">
                            <div class="top-block">
                                年人均产量(万方/人):<span style="color:#21BDCC">{{ getPersonAvgData.yield_avg_year | toFixedNumber }}</span>
                            </div>
                            <div class="top-block">
                                年人均产值(万元/人):<span style="color:#5588F1">{{ getPersonAvgData.value_avg_year | toFixedNumber }}</span>
                            </div>
                            <div class="top-block">
                                年人均销量(万方/人):<span style="color:#FA8436">{{ getPersonAvgData.sale_avg_year | toFixedNumber }}</span>
                            </div>
                            <div class="top-block">
                                年人均运量(万方/人):<span style="color:#EB656F">{{ getPersonAvgData.carriage_avg_year | toFixedNumber }}</span>
                            </div>
                        </div>
                        <div class="charts-two">
                            <h2>年人均产量产值分析</h2>
                            <div id="labourChartTwo"></div>
                        </div>
                        <div class="charts-one">
                            <h2>人员数量统计</h2>
                            <div id="labourChartOne"></div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="罐车使用率">
                    <div class="list-three-content">
                        <div class="one-mobile-content">
                            <div class="first-floor">
                                <div>
                                    <p style="color:#21BDCC">
                                        {{ getTankerData.volume_total | toFixedNumber }}
                                    </p>
                                    <span>实际运输量(万方)</span>
                                </div>
                                <h5 class="shu"></h5>
                                <div>
                                    <p style="color:#FA8436">
                                        {{ getTankerData.join_rate | toFixedNumber }}%
                                    </p>
                                    <span>罐车参运率(%)</span>
                                </div>
                                <h5 class="shu"></h5>
                                <div>
                                    <p style="color:#5588F1">
                                        {{ getTankerData.user_rate | toFixedNumber }}%
                                    </p>
                                    <span>罐车使用率(%)</span>
                                </div>
                            </div>
                            <div class="first-floor second-floor">
                                <div>
                                    <p style="color:#21BDCC">
                                        {{ getTankerData.transport_mileage | toFixedNumber }}
                                    </p>
                                    <span>运输里程(百公里)</span>
                                </div>
                                <h5 class="shu"></h5>
                                <div>
                                    <p style="color:#FA8436">
                                        {{ getTankerData.transport_number || 0 }}
                                    </p>
                                    <span>运输次数(趟)</span>
                                </div>
                                <h5 class="shu"></h5>
                                <div>
                                    <p style="color:#5588F1">
                                        {{ getTankerData.ability_single_use | toFixedNumber }}
                                    </p>
                                    <span>参运单车运输方量（方/辆*次)</span>
                                </div>
                            </div>
                        </div>
                        <div class="line-ability">
                            <div class="three-title">
                                <h2>罐车数量</h2>
                                <span>单位(辆)</span>
                            </div>
                            <div class="ability-content">
                                <div>
                                    <span>总数量</span>
                                    <p>{{ getTankerData.number || 0 }}</p>
                                </div>
                                <div>
                                    <span>参运</span>
                                    <p>{{ getTankerData.number_use || 0 }}</p>
                                </div>
                                <div>
                                    <span>闲置</span>
                                    <p>{{ getTankerData.number_free || 0 }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="line-ability">
                            <div class="three-title">
                                <h2>运输能力</h2>
                                <span>单位(万方)</span>
                            </div>
                            <div class="ability-content">
                                <div>
                                    <span>总能力</span>
                                    <p>{{ getTankerData.ability | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>参运</span>
                                    <p>{{ getTankerData.ability_use | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>闲置</span>
                                    <p>{{ getTankerData.ability_free | toFixedNumber }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="line-ability">
                            <div class="three-title">
                                <h2>罐车价值</h2>
                                <span>单位(万元)</span>
                            </div>
                            <div class="ability-content">
                                <div>
                                    <span>总价值</span>
                                    <p>{{ getTankerData.value | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>参运</span>
                                    <p>{{ getTankerData.value_use | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>闲置</span>
                                    <p>{{ getTankerData.value_free | toFixedNumber }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="line-ability">
                            <div class="three-title">
                                <h2>单车运输能力</h2>
                                <span>单位(方/辆*次)</span>
                            </div>
                            <div class="ability-content">
                                <div>
                                    <span>总能力</span>
                                    <p>{{ getTankerData.ability_single | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>参运</span>
                                    <p>{{ getTankerData.ability_use_single | toFixedNumber }}</p>
                                </div>
                                <div>
                                    <span>闲置</span>
                                    <p>{{ getTankerData.ability_free_single | toFixedNumber }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import utils from '@/assets/js/utils';
import { Dialog } from 'vant';
export default {
    data() {
        return {
            selectTimeYear: '',
            selectTimeMonth: '',
            orgId: '',
            active: 0,
            currentDate: new Date(),
            maxDate: '',
            showPickerTime: false,
            // 拉取上月混凝土资产使用(产能)
            getCapacityConcreteData: {},
            oneData: [],
            oneChartX: [],
            oneChartYOne: [],
            oneChartYTwo: [],
            // 拉取上月砂浆资产使用(产能)
            getCapacityMortarData: {},
            twoData: [],
            twoChartX: [],
            twoChartYOne: [],
            twoChartYTwo: [],
            // 年人均产量产值分析
            getPersonProductionData: {},
            threeChartX: [],
            threeChartYOne: [],
            threeChartYTwo: [],
            // 上月人员数量统计
            getPersonCountData: {},
            fourChartX: [],
            fourChartYOne: [],
            fourChartYTwo: [],
            fourChartYThree: [],
            lineNumberArr: ['管理与其他', '销售', '司机'],
            lineColorArr: ['#FCA736', '#5588F1', '#21BDCC'],
            seriesData: [],
            // 拉取上月年人均生产率信息
            getPersonAvgData: {},
            // 获取上月罐车使用情况
            getTankerData: {},
        };
    },
    components: {
        HeaderNav,
    },
    created() {
        const obj = utils.getPreMon();
        this.maxDate = new Date(obj.year, obj.month - 1, obj.lastDate);
    },
    mounted() {
        this.selectTimeYear = this.$route.query.year;
        this.selectTimeMonth = this.$route.query.month;
        const value = this.$store.state.orgData[0].value;
        this.orgId = value;
        if (this.active === 0) {
            this.getCapacityConcrete();
            this.getCapacityMortar();
        } else if (this.active === 1) {
            this.getPersonProduction();
            this.getPersonCount();
            this.getPersonAvg();
        } else {
            this.getTanker();
        }
    },
    methods: {
        // 时间选择
        selectTime(value) {
            this.selectTimeYear = utils.timeFormat(value, 'year');
            this.selectTimeMonth = utils.timeFormat(value, 'month');
            this.showPickerTime = false;
            this.getNewOrgId();
        },
        getNewOrgId(value) {
            this.orgId = value;
            if (this.active === 0) {
                this.getCapacityConcrete();
                this.getCapacityMortar();
            } else if (this.active === 1) {
                this.getPersonProduction();
                this.getPersonCount();
                this.getPersonAvg();
            } else {
                this.getTanker();
            }
        },
        // 拉取上月混凝土资产使用(产能)
        getCapacityConcrete() {
            this.oneChartX = [];
            this.oneChartYOne = [];
            this.oneChartYTwo = [];
            this.$axios
                // .get('/interfaceApi/report/AssetUseManager/get_capacity_concrete?date=2019-03-10')
                .get(`/interfaceApi/report/AssetUseManager/get_capacity_concrete?date=${this.selectTimeYear}-${this.selectTimeMonth}`)
                .then(res => {
                    this.getCapacityConcreteData = res;
                    this.oneData = res.AbilityAreaList;
                    this.oneData.forEach(item => {
                        this.oneChartX.push(item.org_name || 0);
                        this.oneChartYOne.push(item.number_use || 0);
                        this.oneChartYTwo.push(item.number_free || 0);
                    });
                    this.shangTong();
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        // 拉取上月砂浆资产使用(产能)
        getCapacityMortar() {
            this.twoChartX = [];
            this.twoChartYOne = [];
            this.twoChartYTwo = [];
            this.$axios
                .get(`/interfaceApi/report/AssetUseManager/get_capacity_mortar?date=${this.selectTimeYear}-${this.selectTimeMonth}`)
                .then(res => {
                    this.getCapacityMortarData = res;
                    this.twoData = res.AbilityAreaList;
                    this.twoData.forEach(item => {
                        this.twoChartX.push(item.org_name || 0);
                        this.twoChartYOne.push(item.number_use || 0);
                        this.twoChartYTwo.push(item.number_free || 0);
                    });
                    this.shajiang();
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        // 拉取上月年人均生产率信息
        getPersonAvg() {
            this.$axios
                .get(`/interfaceApi/report/AssetUseManager/get_person_avg?date=${this.selectTimeYear}-${this.selectTimeMonth}`)
                .then(res => {
                    this.getPersonAvgData = res;
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        // 年人均产量产值分析
        getPersonProduction() {
            this.threeChartX = [];
            this.threeChartYOne = [];
            this.threeChartYTwo = [];
            this.$axios
                .get(`/interfaceApi/report/AssetUseManager/get_person_production?date=${this.selectTimeYear}-${this.selectTimeMonth}`)
                .then(res => {
                    this.getPersonProductionData = res;
                    res.forEach(item => {
                        let aArr;
                        if (item.yield_avg_year) {
                            aArr = item.yield_avg_year.toFixed(2);
                        } else {
                            aArr = 0;
                        }
                        let bArr;
                        if (item.value_avg_year) {
                            bArr = item.value_avg_year.toFixed(2);
                        } else {
                            bArr = 0;
                        }
                        this.threeChartX.push(item.month + '月');
                        // 产量
                        this.threeChartYOne.push(aArr);
                        // 产值
                        this.threeChartYTwo.push(bArr);
                    });
                    this.drawChart();
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },

        // 上月人员数量统计
        getPersonCount() {
            this.fourChartX = [];
            this.fourChartYOne = [];
            this.fourChartYTwo = [];
            this.fourChartYThree = [];
            this.$axios
                .get(`/interfaceApi/report/AssetUseManager/get_person_count?date=${this.selectTimeYear}-${this.selectTimeMonth}`)
                .then(res => {
                    this.getPersonCountData = res;

                    this.seriesData = [];
                    res.forEach(item => {
                        this.fourChartX.push(item.month + '月');
                        // 司机的21个
                        this.fourChartYOne.push(item.driver_count);
                        // 销售的12个
                        this.fourChartYTwo.push(item.sale_count);
                        // 其他的12个
                        this.fourChartYThree.push(item.other_count);
                    });
                    this.lineNumberArr.forEach((line, idx) => {
                        let obj = {};
                        switch (this.lineNumberArr[idx]) {
                            case '销售':
                                obj = {
                                    name: this.lineNumberArr[idx],
                                    type: 'bar',
                                    stack: '总量',
                                    data: this.fourChartYTwo,
                                    color: this.lineColorArr[idx],
                                };
                                break;
                            case '管理与其他':
                                obj = {
                                    name: this.lineNumberArr[idx],
                                    type: 'bar',
                                    stack: '总量',
                                    data: this.fourChartYThree,
                                    color: this.lineColorArr[idx],
                                };
                                break;
                            case '司机':
                                obj = {
                                    name: this.lineNumberArr[idx],
                                    type: 'bar',
                                    stack: '总量',
                                    data: this.fourChartYOne,
                                    color: this.lineColorArr[idx],
                                };
                                break;
                        }
                        this.seriesData.push(obj);
                    });
                    this.peopleNumber();
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        // 获取上月罐车使用情况
        getTanker() {
            this.$axios
                .get(`/interfaceApi/report/AssetUseManager/get_tanker?date=${this.selectTimeYear}-${this.selectTimeMonth}`)
                .then(res => {
                    this.getTankerData = res;
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        changeActive() {
            if (this.active === 0) {
                this.getCapacityConcrete();
                this.getCapacityMortar();
            } else if (this.active === 1) {
                this.getPersonProduction();
                this.getPersonCount();
                this.getPersonAvg();
            } else {
                this.getTanker();
            }
        },
        shangTong() {
            const myChart = this.$echarts.init(document.getElementById('threeChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                legend: {
                    data: ['运行条数', '闲置条数'],
                    itemWidth: 10,
                    itemHeight: 10,
                    padding: 35,
                },
                xAxis: {
                    type: 'category',
                    data: this.oneChartX,
                    color: '#979EA7',
                    splitLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: {
                        formatter: '{value}',
                        fontSize: 10, // 字体大小
                    },
                    // 设置边框样式
                    axisLine: {
                        lineStyle: {
                            color: '#979EA7',
                        },
                    },
                },
                yAxis: {
                    type: 'value',
                    name: '单位(条)',
                    splitLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: {
                        fontSize: 10, // 字体大小
                    },
                    // 设置边框样式
                    axisLine: {
                        lineStyle: {
                            color: '#979EA7',
                        },
                    },
                },
                series: [
                    {
                        name: '运行条数',
                        type: 'bar',
                        stack: '总量',
                        label: {
                            show: true,
                            position: 'insideRight',
                        },
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        data: this.oneChartYOne,
                        barWidth: 20,
                        color: '#FCA736',
                    },
                    {
                        name: '闲置条数',
                        type: 'bar',
                        stack: '总量',
                        label: {
                            show: true,
                            position: 'insideRight',
                        },
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        data: this.oneChartYTwo,
                        barWidth: 20,
                        color: '#5588F1',
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        shajiang() {
            const myChart = this.$echarts.init(document.getElementById('threeChartT'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                legend: {
                    data: ['运行条数', '闲置条数'],
                    itemWidth: 10,
                    itemHeight: 10,
                    padding: 35,
                },
                xAxis: {
                    type: 'category',
                    data: this.twoChartX,
                    color: '#979EA7',
                    splitLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: {
                        formatter: '{value}',
                        fontSize: 10, // 字体大小
                    },
                    // 设置边框样式
                    axisLine: {
                        lineStyle: {
                            color: '#979EA7',
                        },
                    },
                },
                yAxis: {
                    type: 'value',
                    name: '单位(条)',
                    splitLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: {
                        fontSize: 10, // 字体大小
                    },
                    // 设置边框样式
                    axisLine: {
                        lineStyle: {
                            color: '#979EA7',
                        },
                    },
                },
                series: [
                    {
                        name: '运行条数',
                        type: 'bar',
                        stack: '总量',
                        label: {
                            show: true,
                            position: 'insideRight',
                        },
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        data: this.twoChartYOne,
                        barWidth: 20,
                        color: '#FCA736',
                    },
                    {
                        name: '闲置条数',
                        type: 'bar',
                        stack: '总量',
                        label: {
                            show: true,
                            position: 'insideRight',
                        },
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        data: this.twoChartYTwo,
                        barWidth: 20,
                        color: '#5588F1',
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        // tab2
        drawChart() {
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('labourChartTwo'));
            // 指定图表的配置项和数据
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        animation: true,
                        crossStyle: {
                            color: 'red',
                        },
                    },
                },
                legend: {
                    data: ['年人均产量', '年人均产值'],
                    padding: 25,
                },
                textStyle: {
                    fontSize: 10,
                    color: '#979EA7',
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.threeChartX,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '产量(万方/人)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '产值(万元/人)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '年人均产量',
                        type: 'bar',
                        data: this.threeChartYOne,
                        color: '#5588F1',
                        barWidth: 10, // 柱图宽度
                    },
                    {
                        name: '年人均产值',
                        type: 'line',
                        yAxisIndex: 1,
                        data: this.threeChartYTwo,
                        color: '#FA8436',
                    },
                ],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option, true);
        },
        peopleNumber() {
            const myChart = this.$echarts.init(document.getElementById('labourChartOne'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                legend: {
                    data: this.lineNumberArr,
                    itemWidth: 8,
                    itemHeight: 8,
                    y: 30,
                    x: 150,
                },
                xAxis: {
                    type: 'category',
                    data: this.fourChartX,
                    color: '#979EA7',
                    splitLine: { show: false },
                    axisTick: { show: false },
                    // 设置间隔
                    axisLabel: {
                        interval: 0,
                        fontSize: 10, // 字体大小
                    },
                    // 设置边框样式
                    axisLine: {
                        lineStyle: {
                            color: '#979EA7',
                        },
                    },
                },
                yAxis: {
                    type: 'value',
                    name: '单位(人)',
                    splitLine: { show: false },
                    axisTick: { show: false },
                    // 设置间隔
                    axisLabel: {
                        interval: 0,
                        fontSize: 10, // 字体大小
                    },
                    // 设置边框样式
                    axisLine: {
                        lineStyle: {
                            color: '#979EA7',
                        },
                    },
                },
                series: this.seriesData,
            };
            myChart.setOption(option, true);
        },
    },
};

</script>
<style lang='stylus' scoped>
.asset-use-title
    position fixed
    top 0
    left 0
    right 0
    z-index 99
#threeChart
    width 100%
    height 240rpx
    background #fff
#threeChartT
    width 100%
    height 240rpx
    background #fff
#labourChartOne
    width 100%
    height 240rpx
    background #fff
#labourChartTwo
    width 100%
    height 240rpx
    background #fff
.asset-use-box-center
    width 100%
    height 100%;
    padding-top 74rpx
    overflow-y scroll
    background #F0F0F0
.picker-content
    position fixed
    width: 100%;
    z-index 9
    height: 100%;
    background: rgba(0, 0, 0, .4);
    top: 0
    z-index 999
    .van-picker
        position: fixed;
        bottom: 0;
        width: 100%;
.title-tips
    width 100%
    height 30rpx
    font-size 12rpx
    color #333333
    display flex
    justify-content center
    align-items center
    background #F0F0F0
    margin-top 44rpx
    .iconrili
        font-size 18rpx
        margin-right 6rpx
        cursor pointer
        color: #5588F1;
.tab-one
    padding 15rpx
.tab-title-one
    color #3495FB;
    font-size 16rpx
.top-two-block
    display flex
    margin-top 15rpx
    div
        width 165rpx
        height 107rpx
        background #ffffff
        display flex
        flex-direction column
        justify-content center
        align-items center
        &:last-child
            margin-left 15rpx
        h3
            color #333333
            font-size 16rpx
            font-weight 700
        p
            width 115rpx
            height 45rpx
            text-align center
            line-height 45rpx
            margin-top 15rpx
        .two-p-red
            color #EB656F
            background rgba(235,101,111, 0.1)
        .two-p-violet
            color #8B6BEE
            background rgba(139,107,237, 0.1)
.top-three-block
    width 100%
    min-height 50rpx
    background #fff
    margin-top 15rpx
    padding 15rpx
    padding-bottom 0
    .three-title
        display flex
        justify-content space-between
        align-items baseline
        h2
            color #333333
            font-size 16rpx
        span
            color #979EA7
            font-size 10rpx
    .three-content
        display flex
        justify-content space-between
        p
            width 95rpx
            height 30rpx
            border 1px solid #EAEAEA
            display flex
            justify-content center
            align-items center
            margin-top 15rpx
            color #666666
            font-size 12rpx
            span
                font-weight 800
            &:nth-child(1) span
                color #4AAEBC
            &:nth-child(2) span
                color #ED853B
            &:nth-child(3) span
                color #5588F2
.line-ability
    padding 15rpx
    background #fff
    margin-top 15rpx
    border-radius 4rpx
    .three-title
        display flex
        justify-content space-between
        align-items baseline
        h2
            color #333333
            font-size 16rpx
        span
            color #979EA7
            font-size 10rpx
    .ability-content
        display flex
        justify-content space-between;
        align-items center;
        div
            width 95rpx
            height 50rpx
            border 1px solid #EAEAEA
            display flex
            flex-direction column
            justify-content center
            margin-top 15rpx
            align-items center
            &:nth-child(1) p
                color #21BDCC
            &:nth-child(2) p
                color #FA8436
            &:nth-child(3) p
                color #5588F1
            span
                color #666666
                font-size 10rpx
            p
                font-size 16rpx
                font-weight 800
.list-three-content
    padding 0 15rpx 15rpx
    .one-mobile-content
        padding 15rpx
        background #fff
        min-height 100rpx
        margin-top 15rpx
        border-radius 4rpx
        .first-floor
            border-bottom 1px dashed #EAEAEA
            display flex
            justify-content space-between
            align-items center
            padding-bottom 25rpx
            .shu
                width 1px
                height 30rpx
                background #EAEAEA
            div
                flex 1
                display flex
                justify-content center
                align-items center
                flex-direction column
                p
                    font-size 18rpx
                    font-weight 800
                span
                    font-size 10rpx
                    display inline-block
                    text-align center
        .second-floor
            padding-top 15rpx
            border-bottom none
            padding-bottom 0
.labour-production
    padding 15rpx
    .top-block-ride-four
        width 100%
        display flex
        flex-wrap wrap
        justify-content space-between
        .top-block
            width 167rpx
            height 45rpx
            background #fff
            border-radius 4rpx
            display flex
            justify-content center
            align-items center
            color #666666
            font-size 10rpx
            margin-bottom 10rpx
            span
                font-size 18rpx
                font-weight 800
    .charts-one
        background #ffffff
        border-radius 4rpx
        margin-top 15rpx
        h2
            padding 15rpx
            color #333333
            font-size 16rpx
            padding-bottom 0
    .charts-two
        background #ffffff
        border-radius 4rpx
        h2
            padding 15rpx
            color #333333
            font-size 16rpx
            padding-bottom 0
</style>